import React, {Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {
    Container,
    CardBody,
    Row,
    Col
} from 'reactstrap';

import { sizeTemplate } from './SizeTemplate';
export default class SneakerSize extends Component{
  state = {
    sizes: ["4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "14"],
    GsSizes: ["4.5Y", "5Y", "5.5Y", "6Y", "6.5Y", "7Y"]
  }

  _uncutSize = (sizes) => {
    let sortArr = sizes.sort((a,b)=>(a.US-b.US)).map(item => item.US)
    // let insrtDash = sortArr.reduce((acc, cur, index)=>(`${acc} / ${cur}`)).split(' ')
    if (sortArr.length > 20) {
      sortArr.splice(19, 0, '...')
    }
    let showData = sortArr.slice(0, 20).join(' / ')
    return showData

    // return insrtDash.map((num, index)=>(<text key={index}>{num}</text>))
  }

  renderSizes(size) {
    const { gender } = this.props
    const font_size = gender === 'M' || gender === 'F' ? 7 : 6;
    const usSizes = this.props.sizes.map((item, index) => (
      item.US
    ))
    if (usSizes.includes(size)) {
      return (
        <p style={{ fontSize: font_size, color: '#4a4a4a', fontFamily: 'Century Gothic Bold' }}>{size}</p>
      )
    } 
    return (
      <p style={{ fontSize: font_size, color: '#b6b6b6', fontFamily: 'Century Gothic' }}>{size}</p>
    )
  }

  checkingGender() {
    const { gender } = this.props;
    const { male, female, primarySchool, gradeSchool, infantToodler } = sizeTemplate;
    switch (gender) {
      case "GS":
        return gradeSchool;
      case "M":
        return male;
      case "F":
        return female;
      case "P":
        return primarySchool;
      case "IT":
        return infantToodler;
      default: return this.state.sizes;
        break;
    }
  }

  render(){
    const checkGender = this.checkingGender();
    
    return(
      <Container className="wrap__size_list">
        <Row>
          {
            checkGender.map((size, index) => (
              <Col key={index} xs={101} md={101} className="wrap__size_list_item">
               {this.renderSizes(size)}
              </Col>
            ))
          }
        </Row>
      </Container>
    )
  }
}